export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ01.5c9b6d6d.mp3";